// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"567":"gallery2","759":"create-annotation","859":"annotation-tool","966":"login"}[chunkId] + "." + {"567":"a5b3f2a6","759":"94db0dd8","859":"017c8510","966":"bf6007be"}[chunkId] + ".css";
};